// extracted by mini-css-extract-plugin
module.exports = {"container":"_60060571","title":"_a6acdff6"};